// Tier-gating for production features (Analytics = STUDIO). A co-producer
// inherits the OWNER's plan, so this helper runs against whichever
// subscription applies to the production — the user's own (owner) or the
// owner's plan fetched via get_briefing_producer_subscription
// (co-producer). Pure + testable.
//
// Live Tracking deliberately does NOT live here: it is gated by
// hasLiveMapAccess() in @produce/shared, the single rule the crew app and
// the web crew map also use. A second "tier + status" copy here once let a
// co-producer see a lock while the crew saw the map on the same briefing.

import type { ProducerSubscriptionLike } from "@produce/shared";

export type PlanLike = NonNullable<ProducerSubscriptionLike>;

const isActiveStatus = (status?: string | null) => status === "active" || status === "trial";

/** Analytics is available on STUDIO (active/trial), or manual access. */
export function planAllowsAnalytics(plan: PlanLike | null | undefined): boolean {
  if (!plan) return false;
  if (plan.manual_producer_access) return true;
  return plan.plan_tier === "studio" && isActiveStatus(plan.plan_status);
}
